<script setup>
import { useAppStore } from '@user-plugins/store/app'
import { useAuthStore } from '@user-plugins/store/modules/auth'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { useTokenExpiry } from '../composables/useTokenExpiry'

const appStore = useAppStore()
const authStore = useAuthStore()
const router = useRouter()
const { locale } = useI18n()

useTokenExpiry(authStore, router)

if (authStore.authenticated) {
    authStore.fetchUser()
}

// Watch for changes in the Pinia store and update i18n locale
watch(
    () => appStore.locale,
    (newLocale) => {
        locale.value = newLocale
    },
    { immediate: true }
)
</script>

<template>
    <v-app :theme="appStore.theme">
        <router-view></router-view>
    </v-app>
</template>
